import { RFID_QR_CODE_MASK } from '../../../config/devices';

function removeLeadingZeros(hexString: string): string {
  const result = hexString.replace(/^0+/, '');
  return result.length > 0 ? result : '0';
}

export function parseRfidQRCode(decodedText: string, keepLeadingZeros?: boolean): string | null {
  const match = RFID_QR_CODE_MASK.exec(decodedText.trim());
  if (match?.[1]) {
    const val = match[1].toUpperCase();
    return keepLeadingZeros ? val : removeLeadingZeros(val);
  }
  return null;
}
